module.exports = __webpack_public_path__ + "static/media/1.ad38097d.jpg";